import { render, staticRenderFns } from "./frmlogin.vue?vue&type=template&id=1286b822&"
import script from "./frmlogin.vue?vue&type=script&lang=js&"
export * from "./frmlogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports